import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsFileEarmarkArrowDown } from "react-icons/bs";

import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";

const CompletionProof = ({ file }) => (
    <div className="uploadedFilesList m-0">
        <div className="uploadedFilesListInner">
            <span> {file.alias}</span>
            <div className="uploadIconsGroup">
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">{file.real_document_name}</Tooltip>}>
                    <a target="_blank" rel="noopener noreferrer" href={URL_CONFIG.DEV_URL + "uploads/" + file.document_name} className="icons text-cyanBlue">
                        <BsFileEarmarkArrowDown />
                    </a>
                </OverlayTrigger>
            </div>
        </div>
    </div>
);

export default CompletionProof;
